export default "__VITE_ASSET__fd0e279d__"